import { useEffect } from "react";
import {
  useDeleteEmailTemplateMutation,
  useGetEmailTemplateListMutation,
} from "../../../app/services/FieldManagement/EmailTemplateManagement/EmailTemplateManagementApi";
import SearchFilterForm from "./SearchFilterForm";
import { EmailTemplateDataConfig } from "./dataFile/EmailManagementDataConfig";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRef } from "react";
import SwalAlert from "../../../services/swalService/SwalService";
import FinalMolGrid from "../../../components/FinalMolGrid/FinalMolGrid";
import DataLoader from "../../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import { getAuditContext } from "../../../lib/authenticationLibrary";

const EmailTemplateManage = () => {
  const [emialList, setEmailList] = useState();
  const EmailTemplateManageRef = useRef(null);
  const navigate = useNavigate();
  const { confirm, success, error } = SwalAlert();
  const audit = getAuditContext();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    endPage: 100,
    SearchText: null,
    ProjectTypeId: null,
    totalCount: 0,
  });
  const [
    getEmailTemplateList,
    {
      isSuccess: isSuccessEmailList,
      isFetching: isFetchingEmailList,
      data: emailListResponse,
    },
  ] = useGetEmailTemplateListMutation();
  const [
    deleteEmailTemplate,
    {
      isSuccess: isSuccessdeleteEmailTemplate,
      data: deleteEmailTemplateResponse,
    },
  ] = useDeleteEmailTemplateMutation();

  useEffect(() => {
    getEmailList();
  }, []);

  useEffect(() => {
    if (isSuccessdeleteEmailTemplate && deleteEmailTemplateResponse) {
      if (deleteEmailTemplateResponse.hasError === false) {
        success("Email Deleted Successfully");
        getEmailList();
      } else {
        error(deleteEmailTemplateResponse.errorMessage);
      }
    }
  }, [isSuccessdeleteEmailTemplate, deleteEmailTemplateResponse]);

  useEffect(() => {
    if (!isFetchingEmailList && isSuccessEmailList && emailListResponse) {
      setPaginationRequest({
        ...paginationRequest,
        totalCount: emailListResponse.totalCount,
      });
      setEmailList(emailListResponse.itemList);
    }
  }, [isFetchingEmailList, isSuccessEmailList, emailListResponse]);

  const getEmailList = (request) => {
    const req = {
      PageNo: request?.pageNo,
      PageSize: request?.pageSize || 10,
      endPage: request?.endPage,
      SearchText: request?.SearchText || "",
      ProjectTypeId: request?.ProjectTypeId,
    };
    getEmailTemplateList(req);
  };

  const handleDelete = (data) => {
    confirm("Delete", "Are you sure you want to delete", "Yes", "Cancel").then(
      (value) => {
        if (value) {
          const request = {
            id: data.emailTemplateId,
            deletedBy: audit.adminUserId,
            appId: audit.appId,
          };
          deleteEmailTemplate(request);
        }
      }
    );
  };

  const handleEdit = (data) => {
    navigate(`/emailTemplateManagement/${data.emailTemplateId}`);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    getEmailList({
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    });
  };

  const actionHandler = {
    DELETE: handleDelete,
    EDIT: handleEdit,
  };
  return (
    <div className="form-card">
      <SearchFilterForm getEmailList={getEmailList} />
      <h5 className="align-self-end mb-3 mt-3">
        Total Count: {emailListResponse?.totalCount || 0}
      </h5>
      {emialList ? (
        <FinalMolGrid
          ref={EmailTemplateManageRef}
          configuration={EmailTemplateDataConfig}
          dataSource={emialList}
          allowPagination={true}
          onActionChange={actionHandler}
          isLoading={isFetchingEmailList}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
        />
      ) : (
        <DataLoader />
      )}
    </div>
  );
};
export default EmailTemplateManage;
